var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "expand" },
    [
      _c(
        "el-table",
        {
          ref: "tableRef",
          staticClass: "customer-table",
          attrs: {
            border: "",
            fit: "",
            "highlight-current-row": "",
            data: _vm.data,
            size: "small",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "采购地址", prop: "gongyingshang" },
          }),
          _c("el-table-column", {
            attrs: { label: "采购单价", prop: "cgprice" },
          }),
          _c("el-table-column", {
            attrs: { label: "采购数量", prop: "number" },
          }),
          _c("el-table-column", {
            attrs: { label: "采购总价", prop: "cgzprice" },
          }),
          _c("el-table-column", {
            attrs: { label: "是否开票", prop: "sfkp" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          scope.row.sfkp == 1
                            ? "已开"
                            : scope.row.sfsp == 2
                            ? "未税"
                            : "未开"
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "收票状态", prop: "sfsp" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          scope.row.sfsp == 1
                            ? "已到"
                            : scope.row.sfsp == 2
                            ? "未到"
                            : "未税"
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "开票发票号", prop: "kpfph" },
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "200", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "el-icon-edit-outline",
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope)
                          },
                        },
                      },
                      [_vm._v(" 编辑 ")]
                    ),
                    _c(
                      "el-popconfirm",
                      {
                        attrs: {
                          iconColor: "red",
                          title: "确认删除此条数据吗？",
                        },
                        on: {
                          confirm: function ($event) {
                            return _vm.handleDelete(scope, scope.$index)
                          },
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "el-icon-delete",
                            attrs: {
                              slot: "reference",
                              size: "mini",
                              type: "danger",
                            },
                            slot: "reference",
                          },
                          [_vm._v("删除")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("Edit", {
        attrs: {
          dialog: _vm.editDialog,
          "form-data": _vm.editFormData,
          submitLoading: _vm.submitLoading,
        },
        on: { submit: _vm.handleSubmit, close: _vm.handleClose },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }